import Vue from "vue";

const { WOW } = require("wowjs");
Vue.prototype.$wow = new WOW({
  live: true,
  animateClass: 'animate__animated',
  offset: 300
});